import { render, staticRenderFns } from "./ClipboardImageMenu.vue?vue&type=template&id=e1ccf5cc"
import script from "./ClipboardImageMenu.vue?vue&type=script&lang=js"
export * from "./ClipboardImageMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports